import { h } from '@stencil/core';
import { i18n } from 'i18n';
import tripPlanner from 'store/tripPlanner';
import { triggerTrackEvent } from 'utils/events';
import TripItemPoiDetail from './TripItemPoiDetail';
import { Pois } from 'client/types';

export default function TripItemDetail({ show }: { show: boolean }) {
  const getItemType = (): 'FLIGHT' | 'ACCOMMODATION' | 'POI' | 'BASIC' => {
    const itemType = tripPlanner.item?.itemType;
    switch (itemType) {
      case 'TRANSPORTATION_FLIGHT':
        return 'FLIGHT';
      case 'STAY_HOTEL':
      case 'STAY_HOUSE':
        return 'ACCOMMODATION';
      case 'ACTIVITY_GENERAL':
      case 'ACTIVITY_FOOD':
        return 'POI';
      default:
        return 'BASIC';
    }
  };

  const getPoiEntity = () => {
    const poiEntity: Pois = {
      maxZoom: 18,
      minZoom: 2,
      fitBounds: [tripPlanner.item!.position!],
      items: [
        {
          position: tripPlanner.item!.position!,
          type: 'POI',
          metadata: {
            description: tripPlanner.item!.title,
          },
        },
      ],
    };

    return JSON.stringify(poiEntity);
  };

  const onClose = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `trip_detail_close`,
    });
    tripPlanner.showModal = null;
  };

  const isFav = typeof tripPlanner.item?.favId !== 'undefined';
  const isPurchased = tripPlanner.item?.purchased === 'YES';

  const highlightInfo = isPurchased
    ? { icon: 'eva-3-icon-checkmark-circle-filled', variant: 'benefit', text: i18n.t.tripPlanner.hasPurchase }
    : { icon: 'eva-3-icon-favorite-filled', variant: 'default', text: i18n.t.tripPlanner.hasFavorite };

  return show && tripPlanner.item ? (
    <div id="trip-item-modal" role="presentation" class="eva-3-modal-side-sheet fullscreen-modal -show-modal-side-sheet -white -md -right -close-on-left">
      <div class="sheet-container">
        <div class="sheet-header" role="presentation">
          <i class="eva-3-icon-cross modal-close -eva-3-mr-md -eva-3-hide-small" role="button" aria-label={i18n.t.itineraryMapModal.close} onClick={onClose}></i>
          <i class="eva-3-icon-arrow-bold-left modal-close -eva-3-mr-md -eva-3-hide-medium-up" role="button" aria-label={i18n.t.itineraryMapModal.close} onClick={onClose}></i>
        </div>
        <div class="sheet-content" role="presentation">
          {(() => {
            const type = getItemType();
            switch (type) {
              case 'POI':
                return <TripItemPoiDetail show={show} poi={getPoiEntity()} />;
              default:
                return (
                  <div class="item-detail">
                    {tripPlanner.item.position && (
                      <div class="item-map">
                        <chat-map-view data-model={getPoiEntity()} autoHeight={true} />
                      </div>
                    )}
                    <div class="item-content">
                      <div class="item-body">
                        {(isPurchased || isFav) && (
                          <span class={`eva-3-h6 item-status ${highlightInfo.variant}`}>
                            <i class={`${highlightInfo.icon} -eva-3-icon-xsm`} /> {highlightInfo.text}
                          </span>
                        )}
                        <h4 class="eva-3-h4 item-text">{tripPlanner.item.title}</h4>
                        <div class="eva-3-body-1 item-text" innerHTML={tripPlanner.item.detail?.summary} />
                      </div>
                    </div>
                  </div>
                );
            }
          })()}
        </div>
      </div>
    </div>
  ) : null;
}
